"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FilterFormConsumer = void 0;

var _react = _interopRequireDefault(require("react"));

var _FilterFormContext = require("./FilterFormContext");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var FilterFormConsumer = function FilterFormConsumer(WrappedComponent) {
  return function DataViewConsumer(props) {
    // TODO: FIX
    // const filterFormContext = useContext(FilterFormContext);
    // return (<WrappedComponent {...props} {...filterFormContext} />);
    return _react["default"].createElement(_FilterFormContext.FilterFormContext.Consumer, null, function (filterFormContext) {
      return _react["default"].createElement(WrappedComponent, _extends({}, filterFormContext, props));
    });
  };
};

exports.FilterFormConsumer = FilterFormConsumer;